import { Button, Col, Form, Row, Space, Spin, Table } from "antd";
import Icons from "assets/icons";
import React, { useState, useRef, useEffect } from "react";
import "./CSKHManagement.scss";
import { allColumns, fields } from "./config";
import { ColumnProps } from "types/models";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import { InputFields, ListActionButton } from "components/common";
import catalogService from "api/catalog";
import Notification from "components/common/notification/notification";
import customerCare from "api/customerCare";

const CSKHManagement = () => {
  const modalRef = useRef<any>();
  const [form] = Form.useForm();
  const [data, setData] = useState([]);

  const [typeModal, setTypeModal] = useState({
    type: "new",
    text: "",
    id: null,
  });

  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);

  const handleAdd = () => {
    modalRef.current?.openModal();
    setTypeModal({
      type: "new",
      text: "Thêm mới",
      id: null,
    });
    form.resetFields();
    form.setFieldValue("toSeconds", 0);
  };

  const getList = async () => {
    setLoading(true);
    try {
      const res = await catalogService.getListTrangThaiCSKH();

      const newRes = res.map((item) => {
        return {
          ...item,
          toSeconds: item.toSeconds / 3600 / 24 + " ngày",
          key: item.id,
        };
      });

      setData(newRes);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy danh mục phiếu CSKH");
    }
  };

  const handleEdit = async (id) => {
    try {
      modalRef.current?.openModal();

      const res = await customerCare.getDetailById(id);

      setTypeModal({
        type: "old",
        text: "Cập nhật",
        id: id,
      });

      form.setFieldsValue({
        ...res,
        toSeconds: res.toSeconds / 3600 / 24,
      });
    } catch (error) {
      setLoadingModal(false);
      Notification("error", "Đã lấy ra lỗi khi lấy dữ liệu");
    }
  };

  useEffect(() => {
    getList();
  }, []);
  const handleCanle = () => {
    modalRef.current.closeModal();
  };

  const handleDelete = (id) => {
    try {
      customerCare.deleteDetailById(id);
      setData(data.filter((e) => e.id != id));
      Notification("success", "Xóa danh mục thành công");
    } catch (error) {
      Notification("error", "Xóa danh mục không thành công");
    }
  };

  allColumns.find((e) => e.dataIndex == "action").render = (
    v,
    r: { id: number }
  ) => (
    <ListActionButton
      editFunction={() => handleEdit(r.id)}
      deleteFunction={() => handleDelete(r.id)}
    />
  );

  const handleUpdateCatalog = async () => {
    try {
      const getvalue = form.getFieldsValue();
      const data = {
        ...getvalue,
        toSeconds: getvalue.toSeconds * 3600 * 24,
        id: typeModal.id,
      };
      let method: string;
      if (typeModal.type === "new") {
        method = "postDetailById";
      } else method = "putDetailById";
      const res = await customerCare[method](data);

      getList();
      handleCanle();
      form.resetFields();
      Notification("success", `${typeModal.text} thành công`);
    } catch (error) {
      Notification("error", `${typeModal.text} không thành công`);
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="cskh-management">
        <div className="container">
          <div className="header">Danh mục trạng thái chăm sóc khách hàng</div>
          {/* <div className="container-main"> */}
          <Space style={{ width: "100%" }} direction="vertical">
            <Row justify={"end"} gutter={[16, 16]}>
              <Button
                icon={<Icons.add rev={undefined} />}
                type="primary"
                onClick={handleAdd}
              >
                Thêm mới
              </Button>
            </Row>
            <Table columns={allColumns} dataSource={data} bordered />
          </Space>

          <ModalCustom
            ref={modalRef}
            loading={loadingModal}
            width={800}
            title={`${typeModal.text} danh mục trạng thái chăm sóc khách hàng`}
          >
            <Form form={form}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Row gutter={[16, 8]}>
                  <InputFields data={fields} />
                </Row>
                <Row justify={"end"} gutter={[16, 8]}>
                  <Col>
                    <Button onClick={handleCanle}>Hủy</Button>
                  </Col>
                  <Col>
                    <Button type="primary" onClick={handleUpdateCatalog}>
                      Lưu
                    </Button>
                  </Col>
                </Row>
              </Space>
            </Form>
          </ModalCustom>
        </div>
      </div>
      {/* </div> */}
    </Spin>
  );
};

export default CSKHManagement;
